import { render, staticRenderFns } from "./WelcomeDialog.vue?vue&type=template&id=3948e6ce&"
import script from "./WelcomeDialog.vue?vue&type=script&lang=ts&"
export * from "./WelcomeDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports